<template>
	<div class="diagnosis-analyze-details">
		<div class="device-info">
			<gc-header :header-data="headerData">
				<template #status>
					<span :class="['status', status.class]">{{ status.text }}</span>
				</template>
			</gc-header>
		</div>
		<div v-if="streamError" class="diagnosis-error">{{ streamError }}</div>
		<div v-if="hasDetail" class="analyze-tabs">
			<el-radio-group v-model="analyzeTabIdx" size="small">
				<el-radio-button v-for="item in analyzeTabs" :key="item.idx" :label="item.idx">
					{{ item.name }}
				</el-radio-button>
			</el-radio-group>
		</div>
		<div v-if="hasDetail" class="modal-container">
			<!-- 通讯质量分析 -->
			<CommunicateQuality
				v-show="analyzeTabIdx === 1"
				:detail="detail"
				:ai-result="aiResult"
				:ai-running="streamActive"
				:ai-not-required="aiNotRequired"
			/>

			<!-- 关阀分析 -->
			<CloseValve v-show="analyzeTabIdx === 2" :detail="detail" />
		</div>
		<div v-else class="diagnosis-wait-panel">
			<i :class="streamActive ? 'el-icon-loading' : 'el-icon-warning-outline'"></i>
			<span>{{ streamActive ? '正在获取规则诊断结果...' : '未获取到规则诊断结果' }}</span>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { nameTrans } from '@/utils'
import CommunicateQuality from './tabs/CommunicateQuality'
import CloseValve from './tabs/CloseValve'
export default {
	components: { CommunicateQuality, CloseValve },
	data() {
		return {
			analyzeTabIdx: 1,
			analyzeTabs: [
				{ name: '通讯质量分析', idx: 1 },
				{ name: '关阀分析', idx: 2 },
			],
		}
	},
	computed: {
		...mapGetters({
			userInfo: 'userInfo',
			dataList: 'dataList',
		}),
		...mapState('diagnosis', ['detail', 'aiResult', 'streamError']),
		...mapGetters('diagnosis', ['hasDetail', 'streamActive', 'aiNotRequired']),
		headerData() {
			let title = this.detail.deviceTypeName
			if (this.userInfo.tenantType === '1') {
				title = nameTrans(this.detail.userType, this.dataList.userType)
			}
			return {
				pic: 'account-detail',
				title,
				desc: [
					{
						icon: 'icon-bianhao',
						text: this.detail.deviceNo,
					},
					{
						icon: 'icon-daohangdizhi',
						text: this.detail.addressName,
						maxWidth: '40%',
					},
				],
			}
		},
		status() {
			const map = {
				0: {
					text: '待安装',
					class: 'wait-installed',
				},
				1: {
					text: '已安装',
					class: 'installed',
				},
				2: {
					text: '已拆除',
					class: 'had-uninstalled',
				},
			}
			return {
				text: map[this.detail.deviceStatus]?.text || '',
				class: map[this.detail.deviceStatus]?.class || '',
			}
		},
	},
	created() {
		const { deviceId } = this.$route.query
		if (this.$route.params.analyzeTabIdx) {
			this.analyzeTabIdx = this.$route.params.analyzeTabIdx
		}
		if (!deviceId) {
			return this.$message.error('未找到设备id')
		}
		this.$store
			.dispatch('diagnosis/ensureDiagnosis', { deviceId })
			.catch(error => this.$message.error(error.message))
	},
}
</script>
<style lang="scss" scoped>
.diagnosis-analyze-details {
	height: 100%;
	display: flex;
	flex-direction: column;
	.device-info {
		display: flex;
		flex-direction: column;
		.installed {
			background: #e4f5ec;
			color: #16a65d;
			&::before {
				position: absolute;
				top: 8px;
				left: 10px;
				display: block;
				content: '';
				width: 4px;
				height: 4px;
				border-radius: 50%;
				background-color: #16a65d;
			}
		}
	}

	.analyze-tabs {
		padding: 12px 24px;
		border-bottom: 1px solid #f1f1f1;
	}
	.modal-container {
		flex: 1;
		height: 0;
		padding: 0 24px 12px;
		overflow-y: scroll;
	}
	.diagnosis-error,
	.diagnosis-wait-panel {
		margin: 0 24px 12px;
		padding: 14px 16px;
		border-radius: 4px;
		background: #f0f3fc;
		color: #5f667d;
		i {
			margin-right: 8px;
		}
	}
	.diagnosis-error {
		background: #e5662e1a;
		color: #e5662e;
	}
}
</style>
